import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col, ProgressBar } from "react-bootstrap";
import revenueOverview from "assets/images/icons/revenueOverview.svg";
import dollar from "assets/images/icons/dollar.svg";
import Riyal from "assets/images/icons/riyal.svg";
import averageBooking from "assets/images/icons/averageBooking.svg";
import info2 from "assets/images/icons/info2.svg";
import averageBookingTooltip from "assets/images/averageBookingTooltip.png";
import coin from "assets/images/icons/coin.svg";
import { AverageBookingsIcon, DollarIcon, RevenueOverviewIcon } from "components/common/SVGIcons";

const RevenueOverview = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipType, setTooltipType] = useState(null);
  const { brandInfo } = useSelector((state) => state.auth);
  const { primaryColor } = brandInfo?.theme?.themeColors  || {};

  const tooltipRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  const {
    totalRevenue,
    planRevenue,
    planRevenuePercentage,
    avgRevenuePerDay,
    avgRevenuePerBooking,
  } = overviewDashboard?.totalAvgRevenueStats || {};

  return (
    <Col lg={12}>
      <div className="inner_section">
        <div className="title_section">
          <RevenueOverviewIcon color={primaryColor}/>
          <h2 className="fs_20 text_black">{t("Revenue")}</h2>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <DollarIcon color={primaryColor} width={24} height={24} />
            <h2 className="fs_14 text_black mt-2">{t("Total Revenue")}</h2>
            <div className="d-flex align-items-center gap-2 mt-3">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {totalRevenue?.toLocaleString("en-US")}
              </h2>
            </div>
            <div className="d-flex gap-3 mt-2 occupancy_inner">
              <div className="d-flex gap-1">
                <img
                  src={coin}
                  width={15}
                  height={15}
                  alt="icon"
                  className="mx-1"
                />
                <p className="fs_12 text_dark_gray">{t("Plan Revenue")}</p>
              </div>
              <div className="">
                <h2 className="fs_14 text_black">
                  <img src={Riyal} width={12} height={12} alt="riyal" />
                  {planRevenue?.toLocaleString("en-US")}
                </h2>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <p className="fs_14 text_black">
                    {planRevenuePercentage ?? 0}%
                  </p>
                  <div className="custom_progressbar">
                    <ProgressBar now={planRevenuePercentage} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="single_item">
            <AverageBookingsIcon color={primaryColor} />
            <div
              className="d-flex align-items-center mt-2 gap-1 position-relative"
              ref={tooltipRef}
            >
              <h2 className="fs_14 text_black ">
                {t("Average Revenue Per Day")}
              </h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => {
                  setTooltipType(1);
                  setShowTooltip(!showTooltip);
                }}
              />
              {showTooltip && tooltipType === 1 && (
                <img
                  src={averageBookingTooltip}
                  width={450}
                  height={580}
                  alt="info"
                  className="c_p tooltip_img"
                  style={{ left: "-47px", right: "unset" }}
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-3">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {avgRevenuePerDay?.toLocaleString("en-US")}
              </h2>
            </div>
          </div>
          <div className="single_item">
            <AverageBookingsIcon color={primaryColor} />

            <div
              className="d-flex align-items-center mt-2 gap-1 position-relative"
              ref={tooltipRef}
            >
              <h2 className="fs_14 text_black">
                {t("Average Revenue Per Booking")}
              </h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => {
                  setTooltipType(2);
                  setShowTooltip(!showTooltip);
                }}
              />
              {showTooltip && tooltipType === 2 && (
                <img
                  src={averageBookingTooltip}
                  width={450}
                  height={580}
                  alt="info"
                  className="c_p tooltip_img"
                  style={{ left: "-19px", right: "unset" }}
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-3">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {avgRevenuePerBooking?.toLocaleString("en-US")}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default RevenueOverview;
